import { FormControl, FormControlProps, Textarea, TextareaProps } from '@chakra-ui/react'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import FormError from '../FormError'
import FormLabel from '../FormLabel'
import styles from './TextAreaInput.module.scss'

interface TextAreaInputProps extends TextareaProps {
  label: string
  name: string
  required?: boolean
  disabled?: boolean
  defaultValue: string
  type?: string
  accept?: string
  multiple?: boolean
  allowClear?: boolean
}

const TextAreaInput: React.FC<TextAreaInputProps & FormControlProps> = ({
  label,
  defaultValue,
  name,
  required,
  disabled,
  ...rest
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  return (
    <FormControl {...rest}>
      <FormLabel required={required}>{label}</FormLabel>
      <div className={styles.inputContainer}>
        <Textarea {...register(name)} defaultValue={defaultValue} data-testid={name} isDisabled={disabled} {...rest} />
      </div>
      <FormError>{errors[name]?.message}</FormError>
    </FormControl>
  )
}

export default TextAreaInput
